/**
 * Product Hotspot Component
 * Handles interactive product hotspots on banner images
 */

console.log('[Hotspot Debug] Script loaded');

if (!customElements.get('product-hotspot')) {
  console.log('[Hotspot Debug] Registering product-hotspot custom element');

  class ProductHotspot extends HTMLElement {
    constructor() {
      super();
      console.log('[Hotspot Debug] ProductHotspot constructor called');
      this.attachEventListeners();

      // Debug: Check if element is receiving mouse events
      this.addEventListener('mousemove', () => {
        console.log('Hotspot receiving mousemove');
      }, { once: true });
    }

    attachEventListeners() {
      // Click on hotspot dot to toggle tooltip
      this.addEventListener('click', (e) => {
        const tooltip = this.querySelector('.product-hotspot__tooltip');

        // If clicked on tooltip, navigate to product
        if (tooltip && tooltip.contains(e.target)) {
          e.preventDefault();
          e.stopPropagation();
          this.navigateToProduct();
          return;
        }

        // If clicked on dot, toggle tooltip
        e.preventDefault();
        e.stopPropagation();
        this.toggleActive();
      });

      // Close on outside click
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target) && this.classList.contains('active')) {
          this.classList.remove('active');
        }
      });
    }

    toggleActive() {
      // Close other active hotspots
      const container = this.closest('product-hotspot-container');
      if (container) {
        container.querySelectorAll('product-hotspot.active').forEach(hotspot => {
          if (hotspot !== this) {
            hotspot.classList.remove('active');
          }
        });
      }

      this.classList.toggle('active');
    }

    navigateToProduct() {
      const url = this.getAttribute('data-product-url');
      if (url) {
        window.location.href = url;
      }
    }
  }

  customElements.define('product-hotspot', ProductHotspot);
}

/**
 * Product Hotspot Container
 * Manages multiple hotspots within a banner
 */
if (!customElements.get('product-hotspot-container')) {
  class ProductHotspotContainer extends HTMLElement {
    constructor() {
      super();
      // Container is now passive, just holds hotspots
    }
  }

  customElements.define('product-hotspot-container', ProductHotspotContainer);
}
